import { render, staticRenderFns } from "./NewEditEventosCalendarioLetivoPage.vue?vue&type=template&id=5411c271&scoped=true"
import script from "./NewEditEventosCalendarioLetivoPage.vue?vue&type=script&lang=js"
export * from "./NewEditEventosCalendarioLetivoPage.vue?vue&type=script&lang=js"
import style0 from "./NewEditEventosCalendarioLetivoPage.vue?vue&type=style&index=0&id=5411c271&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5411c271",
  null
  
)

export default component.exports